import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { Observable } from 'rxjs';
import { ContentAndStatus } from '../../Models/OtherClasses';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class ReservationService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('Reservation');
	}

	getSuggestedDates(id: System.Guid, isDelivery: boolean, after: Date): Observable<TooBig4Car.Logic.DateSuggestionVM[]> {
		var urlToUse = this.url + '/' + (id || '') + '/DateSuggestions'
			+ '?isDelivery=' + (isDelivery || false).toString();
		if (after) {
			urlToUse += '&after=' + DateTime.fromJSDate(after).toISO();
		}
		return this.myBaseService.loadAll(urlToUse);
	}

	get(id: string): Observable<ContentAndStatus<TooBig4Car.Logic.ReservationQuestionaireVM>> {
		return this.myBaseService.getPlainErrorOptionWithStatusCode(this.url + '/' + (id || ''), 'Failed to Load', true);
	}

	getTracker(id: string): Observable<ContentAndStatus<TooBig4Car.Logic.PUDStatusWidgetVM>> {
		return this.myBaseService.getPlainErrorOptionWithStatusCode(this.url + '/Tracker/' + (id || ''), 'Failed to Load', true);
	}

	getCompanyData(id: string): Observable<TooBig4Car.Logic.Company> {
		return this.myBaseService.get(id, this.url + '/Company');
	}

	ValidateOffScheduleDate(id: string | System.Guid, date: Date): Observable<boolean> {
		var dateStr = '';
		if (date) {
			dateStr = DateTime.fromJSDate(new Date(date)).toISO();
		}
		return this.myBaseService.post(date, this.url + '/ValidateOffScheduleDate/' + id.toString(), true);
	}
	save(tempItem: TooBig4Car.Logic.ReservationQuestionaireVM): Observable<string> {
		return this.myBaseService.post(tempItem, this.url, true);
	}
}

